import React from "react";
import { Link } from "react-router-dom";
import { Wrench, ArrowLeft, Sparkles } from "lucide-react";

/* ================================================================
   Placeholder page for Phase 5 UI entry points during Rebrand Sprint.
   Backend endpoints remain live for internal QA; wizard route
   (`/app/skills/new`, `/app/skills/:skillId`) is still reachable
   directly.
   ================================================================ */

export default function SkillsMaintenance() {
    return (
        <div
            className="h-full overflow-y-auto atlas-scrollbar grid place-items-center px-6 py-12"
            data-testid="skills-maintenance"
        >
            <div className="max-w-[520px] w-full text-center">
                <div
                    className="mx-auto w-14 h-14 rounded-2xl grid place-items-center mb-6"
                    style={{
                        background: "linear-gradient(135deg, rgba(139,92,246,0.22), rgba(139,92,246,0.06))",
                        border: "1px solid rgba(139,92,246,0.45)",
                        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.1), 0 0 40px -8px var(--atlas-primary-glow)",
                    }}
                >
                    <Wrench
                        className="w-6 h-6"
                        strokeWidth={1.75}
                        style={{ color: "var(--atlas-primary-hover)" }}
                    />
                </div>
                <span className="atlas-hero-eyebrow mb-4">
                    <Sparkles className="w-3 h-3" strokeWidth={2.5} />
                    Skill Studio
                </span>
                <h1
                    className="atlas-text-gradient mt-4 text-[36px] sm:text-[44px] font-bold leading-[1.05]"
                    data-testid="skills-maintenance-title"
                >
                    Skill Studio is being upgraded.
                </h1>
                <p
                    className="mt-4 text-[15px] leading-relaxed"
                    style={{ color: "var(--atlas-text-secondary)" }}
                >
                    We're rebuilding the Skill Studio and Workforce Skill Marketplace against the new Nexus One design language. Back in a few days with the full wizard, marketplace, and installed-skills panel — polished for the enterprise decision surface.
                </p>
                <p
                    className="mt-3 text-[12.5px]"
                    style={{ color: "var(--atlas-text-muted)" }}
                >
                    Existing skill installations, drafts, and run history are safe and untouched during the upgrade.
                </p>
                <div className="mt-8 flex items-center justify-center gap-2">
                    <Link
                        to="/app"
                        className="atlas-btn-primary inline-flex items-center gap-1.5 rounded-lg px-4 h-10 text-[13.5px]"
                        data-testid="skills-maintenance-home"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} /> Back to Home
                    </Link>
                    <Link
                        to="/app/workforce"
                        className="atlas-btn-ghost inline-flex items-center gap-1.5 rounded-lg px-4 h-10 text-[13.5px] font-medium"
                        data-testid="skills-maintenance-workforce"
                    >
                        Workforce Marketplace
                    </Link>
                </div>
            </div>
        </div>
    );
}
